import SchedulesPage from '@/components/pages/SchedulesPage/SchedulesPage'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v4'

const schedulesSearchSchema = z.object({
  page: z.number().int().min(1).optional().catch(undefined),
  app: z.string().optional().catch(undefined),
  sort: z.enum(['created_at', 'updated_at']).optional().catch(undefined),
})

export const Route = createFileRoute('/$workspaceName/$environment/schedules')({
  validateSearch: (search) => schedulesSearchSchema.parse(search),
  component: SchedulesPage,
})
